// src/app/core/guards/role.guard.ts
import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService, UserRole} from '../service/auth.service';

export const roleGuard: CanActivateFn = (route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    const required = (route.data?.['roles'] as UserRole[] | undefined) ?? [];

    if (auth.hasAnyRole(required)) {
        return true;
    }

    if (auth.isAuthenticated()) {
        return router.createUrlTree(['/dashboard'], {
            queryParams: {forbidden: state.url},
        });
    }

    return router.createUrlTree(['/login'], {
        queryParams: {redirectTo: state.url},
    });
};
